export default "__VITE_ASSET__BbDfnqLI__"